import { render, staticRenderFns } from "./Wisdomscreen.vue?vue&type=template&id=36b90096"
import script from "./Wisdomscreen.vue?vue&type=script&lang=js"
export * from "./Wisdomscreen.vue?vue&type=script&lang=js"
import style0 from "./Wisdomscreen.vue?vue&type=style&index=0&id=36b90096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports